<script setup>
import { PopoverAnchor, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: undefined },
  as: { type: [String, Object], default: undefined },
  reference: { type: Object, default: undefined },
});

const forwardedProps = useForwardProps(props);
</script>

<template>
  <PopoverAnchor v-bind="forwardedProps" data-slot="popover-anchor">
    <slot />
  </PopoverAnchor>
</template>
